import axios from 'axios'
import store from '@/store'
import utils from './utils'

const apiServices = {
  getAll: function (url, isPrivate, startIndex = 1, itemPerPage = 5, searchValue = '', ID ) {
    let urlFinal = ''
    if (isPrivate) {
      urlFinal = utils.getAPIURL(url, true).concat(`&start_index=${startIndex - 1}&item_per_page=${itemPerPage}&search_value=${searchValue}`)
    } else {
      urlFinal = utils.getAPIURL(url, false, ID)
    }

    return axios.get(urlFinal)
      .then(response => response.data
      )
      .catch(function (error) {
        if (!error.response || error.response.status === 403) {
          window.location.href = '/#/login'
        }
      })
  },
  getItem: function (url, isPrivate, id) {
    return axios.get(utils.getAPIURL(url, isPrivate, id))
      .then(response => response.data.length > 0 ? response.data[0] : window.location.href = `/#/404` // si existe devuelve el primero del array, de no existir redirecciona a la url
      )
      .catch(function (error) {
        if(isPrivate)
          if (!error.response || error.response.status === 403) {
            window.location.href = '/#/login'
          }
      })
  },
  addItem: function (url, body) {
    return axios.post(utils.getAPIURL(url, true), body)
      .then(response => response
      )
      .catch(function (error) {
        if (!error.response || error.response.status === 403) {
          window.location.href = '/#/login'
        }
      })
  },
  updateItem: function (url, id, body) {
    return axios.patch(utils.getAPIURL(url, true, id), body)
      .then(response => response
      )
      .catch(function (error) {
        if (!error.response || error.response.status === 403) {
          window.location.href = '/#/login'
        }
      })
  },
  deleteItem: function (url, id) {
    return axios.delete(utils.getAPIURL(url, true, id))
      .then(response => response
      )
      .catch(function (error) {
        if (!error.response || error.response.status === 403) {
          window.location.href = '/#/login'
        }
      })
  },
  setStatsWelcomeModal: function (url, id) {
    if (window.location.hash && window.location.hash.includes('share=true')) {
      return Promise.resolve(null)
    }

    const body = {
      MenuID: id,
      EnterpriseID: ''
    }

    return axios.post(utils.getAPIURL(url, false), body)
      .then(response => response
      )
      .catch(function (error) {
        if (!error.response || error.response.status === 403) {
          window.location.href = '/#/login'
        }
      })
  },
  setStats: function (url, id) {
    const src = localStorage.getItem('statsSRC')

    if (window.location.hash && window.location.hash.includes('share=true')) {
      return Promise.resolve(null)
    }
      return axios.post(`https://cm-dtouch-stats-api.dtouch.es/v1/public/stats/m/stats`, {
        MenuID: id,
        WorkspaceID: store.state.app.dtouchWorkspace,
        SRC: src && src.length > 0 ? src : null
      })
        .then(response => response)
        .catch((error) => {
          console.log(error)
        })
/*
    return axios.post(utils.getAPIURL(url, false), body)
      .then(response => response
      )
      .catch(function (error) {
        if (!error.response || error.response.status === 403) {
          window.location.href = '/#/login'
        }
      })
    */
  },





  addPublicItem (url, body) {
    return axios.post(utils.getAPIURL(url, true).replace('private', 'public'), body)
      .then(response => response
      )
      .catch(function (error) {
        if (!error.response || error.response.status === 403) {
          window.location.href = '/#/login'
        }
      })
  },

  deletePublicItem: function (url, id) {
    return axios.delete(utils.getAPIURL(url, false, id))
      .then(response => response
      )
      .catch(function (error) {
        if (!error.response || error.response.status === 403) {
          window.location.href = '/#/login'
        }
      })
  },
  put (url, isPrivate, id, body) {
    return axios.put(utils.getAPIURL(url, isPrivate, id), body)
      .then(response => response
      )
      .catch(function (error) {
        if (!error.response || error.response.status === 403) {
          window.location.href = '/#/login'
        }
      })
  },

}

export default apiServices
